import React from 'react';
import { ArticleRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { FONT_FAMILY } from '../common/sharedFunctions';

const accent = '#B7EE00';
const ink = '#111411';

const LegalDocument = ({ children, description, label }) => (
  <Box>
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      sx={{
        alignItems: { xs: 'flex-start', sm: 'center' },
        backgroundColor: '#F4F7EF',
        border: '1px solid #E2E7DD',
        borderRadius: '18px',
        mb: { xs: 3, sm: 4 },
        p: { xs: 2.25, sm: 2.75 }
      }}
    >
      <Box sx={{
        alignItems: 'center',
        backgroundColor: ink,
        borderRadius: '13px',
        color: accent,
        display: 'flex',
        height: 46,
        justifyContent: 'center',
        minWidth: 46
      }}>
        <ArticleRounded />
      </Box>
      <Box>
        <Typography sx={{
          color: ink,
          fontFamily: FONT_FAMILY,
          fontSize: '0.96rem',
          fontWeight: 850,
          mb: 0.35
        }}>
          {label}
        </Typography>
        <Typography sx={{
          color: '#697169',
          fontFamily: FONT_FAMILY,
          fontSize: '0.84rem',
          lineHeight: 1.6
        }}>
          {description}
        </Typography>
      </Box>
    </Stack>

    <Box sx={{
      color: '#5F685F',
      fontFamily: FONT_FAMILY,
      maxWidth: 900,
      '& > p': {
        fontFamily: FONT_FAMILY,
        fontSize: { xs: '0.93rem', sm: '0.98rem' },
        lineHeight: 1.82,
        margin: '0 0 1.2rem',
        overflowWrap: 'anywhere'
      },
      '& > p > strong:only-child': {
        color: ink,
        display: 'block',
        fontSize: { xs: '1.08rem', sm: '1.18rem' },
        fontWeight: 850,
        letterSpacing: '-0.015em',
        marginBottom: '-0.45rem',
        marginTop: '2.1rem'
      },
      '& > ul': {
        backgroundColor: '#F8F9F6',
        borderLeft: `3px solid ${accent}`,
        borderRadius: '0 14px 14px 0',
        fontFamily: FONT_FAMILY,
        fontSize: { xs: '0.91rem', sm: '0.96rem' },
        lineHeight: 1.75,
        margin: '0 0 1.5rem',
        padding: '1.1rem 1.4rem 1.1rem 2.4rem'
      },
      '& > ul > li': {
        marginBottom: '0.55rem',
        paddingLeft: '0.2rem'
      },
      '& > ul > li:last-child': {
        marginBottom: 0
      },
      '& a': {
        color: '#527200',
        fontWeight: 800,
        textDecorationColor: 'rgba(82,114,0,0.35)',
        textUnderlineOffset: '3px'
      }
    }}>
      {children}
    </Box>
  </Box>
);

export default LegalDocument;
